module.exports = {"apiKey":"AIzaSyCLakf3JmBGf4kD4wuPlszgm3Vho1ETV8c","authDomain":"react-auto-repair-shop.firebaseapp.com","databaseURL":"https://react-auto-repair-shop.firebaseio.com","projectId":"react-auto-repair-shop","storageBucket":"","messagingSenderId":"604335721437"}


//////////////////
// WEBPACK FOOTER
// ./src/firebase-config.json
// module id = 445
// module chunks = 0